export const ResumeListTheatre = [
    {
        project: "25th Annual Putnam County Spelling Bee",
        role: "Supporting",
        production: "Carleton University"
    },
];

export const ResumeListMusicVideo = [
    {
        project: "Drop and Dance",
        role: "Background",
        production: "Harea Band"
    },
    {
        project: "Single Life",
        role: "Supporting",
        production: "Vincent Bishop"
    },
];

export const ResumeListCommercial = [
    {
        statement: "List available upon request"
    }
]

export const ResumeListEducation = [
    {
        program: "Summer Intensive Acting for Film & Television",
        instructor: "New York Conservatory for Dramatic Arts (NYCDA)"
    }, 
    {
        program: "Bachelor of Music with Honours (Musical Theatre, Singer-Songwriter)",
        instructor: "Carleton University"
    }
];

export const ResumeListTraining = [
    {
        program: "Industry Network Singing Bootcamp",
        instructor: "Ella Rosa, Casting Call"
    },
    {
        program: "Industry Network Acting Bootcamp",
        instructor: "Polina Frantsena, Casting Call"
    },
    {
        program: "Singing Bootcamp",
        instructor: "Ella Rosa, Casting Call"
    },
    {
        program: "Advanced Acting Bootcamp",
        instructor: "Kenjuan Bentley, Casting Call"
    },
    {
        program: "Agency Audition Basics",
        instructor: "Michael Sollenberger, Casting Call"
    },
    {
        program: "Audition Techniques",
        instructor: "Larry Van Burren, Casting Call"
    },
    {
        program: "Next Step Acting Class",
        instructor: "Michelle Arvizu, LB Studios"
    },
    {
        program: "Adult Commercial and Monologue Workshop",
        instructor: "Gloria Mann"
    },
    {
        program: "All About Acting Workshop",
        instructor: "Colin McMurray"
    },
    {
        program: "Music Theatre Workshop and Masterclass",
        instructor: "Robert Edwin"
    },
    {
        program: "Morgan Casting Bootcamp",
        instructor: "Matthew Morgan"
    }
];

export const ResumeListVoice = [
    {
        program: "Coaching",
        instructor: "Christopher McGovern, NYCDA"
    },
    {
        program: "Coaching",
        instructor: "Ella Rosa"
    },
    {
        program: "Choir",
        instructor: "VOCA Chorus of Toronto"
    },
    {
        program: "Music Theatre Ensemble",
        instructor: "Carleton University"
    },
    {
        program: "Choir",
        instructor: "Carleton University"
    },
    {
        program: "Coaching",
        instructor: "Susan Blyth-Schofield"
    }
];

export const ResumeListSkills = [
    {
        category: "Voice",
        skill: "Mezzo-Soprano (E3 - B5)"
    },
    {
        category: "Instruments",
        skill: "Guitar, Piano"
    },
    {
        category: "Dance",
        skill: "Ballet, Pointe, Jazz, Modern, Lyrical"
    },
    {
        category: "Sports",
        skill: "Soccer, Figure Skating"
    }
];